import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  toggle() {
    $('#side-navigation').toggle();
  }
}
